<template>
    <v-form ref="step3Form"
            v-model="valid"
            lazy-validation>
      <v-row>
        <v-col v-show="showOfflineClasses"
               cols="12">
          <h3 class="mb-3 text-left">若要辦理線下課程／講座，您會對什麼樣的課程／講座有興趣？（選擇性回答）</h3>
          <v-textarea outlined
                      label="線下課程／講座"
                      v-model="offlineClassDescription"></v-textarea>
        </v-col>
        <v-col v-show="showOnlineClasses"
               cols="12">
          <h3 class="mb-3 text-left">若要辦理線上課程，您會對什麼樣的課程有興趣？（選擇性回答）</h3>
          <v-textarea outlined
                      label="線上課程"
                      v-model="onlineClassDescription"></v-textarea>
        </v-col>
      </v-row>

      <v-btn text
             @click="previousStep">
        上一步
      </v-btn>

      <v-btn color="primary"
             @click="nextStep">
        下一步
      </v-btn>
    </v-form>
</template>

<script>
import { db } from '../plugins/db'
const fStore = db.firestore()

export default {
  name: 'Step3',
  props: {
    userId: String,
    showOfflineClasses: Boolean,
    showOnlineClasses: Boolean
  },
  data () {
    return {
      step: 3,
      valid: true,
      offlineClassDescription: '',
      onlineClassDescription: ''
    }
  },
  methods: {
    nextStep () {
      const aboutClasses = {
        offlineClassDescription: this.offlineClassDescription,
        onlineClassDescription: this.onlineClassDescription
      }

      fStore.collection('form-1').doc(this.userId).update({
        aboutClasses: aboutClasses
      }).then(() => {
        this.$emit('goToStep', this.step + 1)
      })
    },
    previousStep () {
      this.$emit('goToStep', this.step - 1)
    }
  }
}
</script>
